import { connect } from 'react-redux';
import isNil from 'lodash/isNil';
import SchoolTuitionView from './SchoolTuitionView';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_EDUCATION_GOAL_API } from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);
  const goalsList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(goalsList, childFirstName);
  const isEditingGoal = !!childEducationGoal.Id;

  const inputAmount = childrenSelector.getInputAmount(state, ownProps) || '';
  const existingAmount = childEducationGoal.Amount;
  const isAmountChanged =
    (!inputAmount && inputAmount === '') || (inputAmount && inputAmount.length > 0);
  const schoolTuitionAmount = isAmountChanged ? inputAmount : existingAmount;

  const selectedEducationType = isNil(childrenSelector.getSelectedEducationType(state, ownProps))
    ? childEducationGoal.EducationType
    : childrenSelector.getSelectedEducationType(state, ownProps);

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    ClientId: clientId,
    Amount: schoolTuitionAmount,
  };

  return {
    clientId,
    schoolTuitionAmount,
    selectedEducationType,
    isEditingGoal,
    educationGoal,
  };
};

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: (data, educationGoal) => ({
    [BACKEND_EDUCATION_GOAL_API]: educationGoal,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SchoolTuitionView);
